import { render } from "./BookSelection.vue?vue&type=template&id=b2b7faa0&scoped=true"
import script from "./BookSelection.vue?vue&type=script&scope=true&lang=js"
export * from "./BookSelection.vue?vue&type=script&scope=true&lang=js"

import "./BookSelection.vue?vue&type=style&index=0&id=b2b7faa0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2b7faa0"]])

export default __exports__